<template>
  <div class="discount_detail">
    <el-card class="box-card" type="card">
      <el-tabs v-model="activeName" @tab-click="handleClick" >
        <el-tab-pane label="返利&现金垫付上账" name="up">
          <DetailTable
            :loading="loading"
            :tableData="tableData"
            :page="page"
            :total="total"
            :hiddenPage="hiddenPage"
            functionCode="fee_discount_detail_on_account_export"
            parentCode="CRM20210127000000842" 
            requestUrl="/fee/hdFeePoolDiscountController/findFeePoolDetailAccountList"
            type="up"
            useType='Y'
            @dateTimeChange="timeChangeSearch"
            @timeReset="timeReset"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
          </DetailTable>
        </el-tab-pane>
        <el-tab-pane disabled label="|"></el-tab-pane>
        <el-tab-pane label="返利&现金垫付使用" name="use">
          <DetailTable
            :loading="loading"
            :tableData="tableData"
            type="use"
            useType='Y'
            :page="page"
            :hiddenPage="hiddenPage"
            :total="total"
            functionCode="fee_discount_detail_use_export"
            parentCode="CRM20210127000000842"
            requestUrl="/fee/hdFeePoolDiscountController/findFeePoolUseList"
            @dateTimeChange="timeChangeSearch"
            @timeReset="timeReset"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            >
          </DetailTable>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
/**
 * @description: 接口 
 * @param {*} discountUpList 折扣上账  
 * @param {*} discountUseList 折扣使用
 * @param {*} DetailTable 表格组件
 * @return {*}
 * @author: txp
 */
import { discountUpList, discountUseList } from "@/api/api";
import { Storage } from "@/utils/storage";
import DetailTable from "./components/DetailTable";
export default {
  name: "DiscountDetail",
  components: { DetailTable },
  data() {
    return {
      activeName: "up", //标签页切换参数
      hiddenPage:false,//页数为1时是否隐藏分页
      page: {
        pageSize: 10, //每页展示的条数
        pageNum: 1, //第几页
      },
      tableData: [],
      total: 0, //数据总条数
      loading:true
    };
  },
  watch:{
    /**
     * @description 监听total数值的变化 无数据时隐藏 分页
     */
    total(newVal,oldVal){
        newVal== 0 ? (this.hiddenPage = true):(this.hiddenPage = false)
    }
  },
  created() {
    this.getDiscountUpDetail(this.getInfo());
  },
  mounted() {},
  methods: {
    /**
     * @description 接口请求参数封装函数
     * @param { String }    customerCode 用户编码
     * @param { Object }    page         分页参数
     */
    getInfo() {
      let customerCode = Storage.l.get("customerCode");
      return {
        customerCode: customerCode,
         ...this.page,
      };
    },
    /**
     * @description 公共Switch函数封装
     * @param { String }    condition   switch 判断条件参数 up 折扣
     * @param { Object }    params      接口请求参数
     */
    switchCommonFunction(condition,params){
      switch (condition) {
        case "up":
          this.getDiscountUpDetail(params);
          break;
        case "use":
          this.getDiscountUseDetail(params);
          break;
      }
    },
    /**
     * @description  折扣上账 接口请求函数
     * @param { Number }    total      数据条数
     * @param { Array }     tableData  表格展示数数组
     */
    getDiscountUpDetail(params) {
      this.loading = true
      discountUpList(params).then((res) => {
        this.total = res.result.count;
        this.tableData = res.result.data;
        this.loading = false
      });
    },
    /**
     * @description  折扣使用 接口请求函数
     */
    getDiscountUseDetail(params) {
      this.loading = true
      discountUseList(params).then((res) => {
        this.total = res.result.count;
        this.tableData = res.result.data;
        this.loading = false
      });
    },
    /**
     * @description  分页标签点击函数
     * @param tab               见element-ui
     * @param event             见element-ui
     * @param { Number }  index tabs点击项的索引
     */
    handleClick(tab, event) {
      this.activeName = tab.name
      this.page.pageNum = 1
      this.switchCommonFunction(this.activeName,this.getInfo())
    },
    /**
     * @description 组件折扣上账日期选择监听查询
     */
    timeChangeSearch(type,timeData) {
      let params = {
        ...timeData,
        ...this.getInfo(),
      };
      this.switchCommonFunction(type,params)
    },
    /**
     * @description 组件折扣上账日期重置函数
     */
    timeReset(type) {
      this.page.pageNum = 1;
      this.switchCommonFunction(type,this.getInfo())
    },
    /**********************页码组件函数***********************/
    /**
     * @description 页码变化监听函数
     * @param { String }   up      折扣类型--上账
     * @param { String }   use     折扣类型--使用
     * @param { Number }   pageNum 页码
     */
    pageChange(type,pageNum){
      this.page.pageNum = pageNum;
      this.switchCommonFunction(type,this.getInfo())
    },
    /**
     * @description 页条数变化监听函数
     * @param { String }   up       折扣类型--上账
     * @param { String }   use      折扣类型--使用
     * @param { Number }   pageSize 每一页显示的数量
     */
    sizeChange(type,pageSize){
      this.page.pageSize = pageSize;
      this.switchCommonFunction(type,this.getInfo())
    }
  },
};
</script>
<style lang="scss" scoped>
.discount_detail {
  height: 100%;
    /deep/ .el-card{
      height: 100%;
        .el-tabs__item{
            font-size: 18px;
            margin-bottom: 7px;
            padding:0px 10px;
        }
        .el-range-editor.el-input__inner{
          width: 236px;
        }
        // 选择日期背景
        .el-range-input{
          background: #F5F5F5;
        }
    }
}
</style>